<template>
  <div>
    <vs-popup :title="$t('RefrenceInfo')" :active.sync="showModal">
      <div class="vx-row mb-6">
        <div class="vx-col w-full my-2">
          <label class="vs-select--label my-1 text-base">{{
            $t("Validity Date Time")
          }}</label>
          <datepicker placeholder="Select Date" class="w-full mt-2 " v-model="model.validityDateTime"></datepicker>
        </div>
        <div class="vx-col w-full my-2">
          <label class="vs-select--label my-1 text-base">{{
            $t("Issue Date Time")
          }}</label>
          <datepicker placeholder="Select Date" class="w-full mt-2 " v-model="model.issueDateTime"></datepicker>
        </div>
        <div class="vx-col w-full my-2">
          <label class="vs-select--label my-1 text-base">{{
            $t("Seller Reference Id")
          }}</label>
          <vs-input v-model="model.sellerReferenceId" class="mt-3" name="rate" />
        </div>

        <div class="flex justify-end w-full ml-5">
          <vs-button
            type="filled"
            class="mb-4 mt-4"
            @click.prevent="submitForm"
            :disabled="!model.validityDateTime || !model.sellerReferenceId || !model.issueDateTime"
            >{{ $t("Save") }}</vs-button
          >
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<style lang="scss">
body[dir="rtl"] .vs-popup--content {
  overflow-y: scroll !important;
}
</style>

<script>
import { mapActions } from "vuex";
import { Validator } from "vee-validate";
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";


const dict = {
  custom: {
    // TargetCurrencyType: {
    //   required: "لطفا ارز مقصد را وارد نمایید.",
    // },
    currencyType: {
      required: "لطفا ارز مبدا را وارد نمایید.",
    },
    bPrice: {
      required: "لطفا نرخ را وارد نمایید.",
    },
  },
};
Validator.localize("fa", dict);

export default {
  components: {
    "v-select": vSelect,
    Datepicker
  },
  props: {
    show: { default: false },
    editModel:{}
  },
  data() {
    return {
      departman: "",
      popupTitle: "",
      disabled: false,
      model: {},
      price: null,
      currencyTypes: [
        { name: "ریال", id: 1 },
        { name: "دلار", id: 2 },
        { name: "درهم", id: 3 },
      ],
    };
  },
  computed: {
    showModal: {
      get: function () {
        if(this.editModel){
          this.model=this.editModel

        }
        else{
          this.model.purchaseInvoiceId = this.$route.params.id;

        }
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {
    ...mapActions({
      updateSellerInfo: "purchaseInvoice/updateSellerInfo",
    }),
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.updateSellerInfo(this.model).then(() => {
            this.$swal({
              position: "center-center",
              type: "success",
              text: "رکورد مورد‌نظر با موفقیت ویرایش شد!",
              showConfirmButton: false,
              timer: 2000,
            });

            this.$emit("finish");
            this.model = {};
            this.price = null;
          });
        } else {
          // form have errors
        }
      });
    },
  },
  // watch: {
  //   show() {
  //     if (this.show == true) {
  //       this.price = this.model.rate.toLocaleString();
  //     }
  //     this.$validator.reset();
  //   },
  //   price(value) {
  //     if (value) {
  //       var n = parseFloat(value.replace(/,/g, ""), 10);
  //       this.price = n.toLocaleString();
  //       this.model.rate = this.price.replace(/,/g, "");
  //     } else {
  //       this.price = null;
  //       this.model.rate = null;
  //     }
  //   },
  // },
};
</script>
<style>
  .vs-popup--content{
    min-height: 500px;

  }
</style>